// extracted by mini-css-extract-plugin
export default {"content":"SlideBar_content__i-Zaq"};